
import { formatTimeShort, formatTimeFriendly } from '@/utils/time'

export default {
  name: 'OrderTimeline',
  props: {
    events: { type: Array, default: () => [] },
    showOperator: { type: Boolean, default: false },
    deliveryPhoto: { type: String, default: '' }
  },
  data () {
    return { showPreview: false }
  },
  computed: {
    previewImages () { return this.deliveryPhoto ? [this.deliveryPhoto] : [] }
  },
  methods: {
    formatTimelineTime (evt) {
      const raw = evt.time || evt.timestamp
      return raw ? formatTimeFriendly(raw) : ''
    },
    statusLabel (s) {
      const map = {
        pending_confirm: '待确认', picked: '已配货', shipped: '(已废弃-验货中)',
        inspected: '已验货', delivering: '配送中', delivered: '已送达',
        confirmed: '已完成', cancelled: '已取消',
        pending: '待处理', in_progress: '处理中', completed: '已完成'
      }
      return map[s] || s
    },
    // 用户端：只暴露配送员/系统标签，隐藏内部角色（管理员/业务员）
    userRoleLabel (label) {
      const visible = { '配送员': '配送员', '系统': '系统' }
      return visible[label] || ''
    },
    isInternalNote (note) {
      // 过滤系统内部实现描述（非业务审计信息）
      const internal = ['认领+执行', '公共配送池', '批量开始配送', 'PC一键验货', '整组验货完成']
      return internal.some(kw => (note || '').includes(kw))
    }
  }
}
